
import React from 'react';
import StartHereTemplate from '../../templates/StartHereTemplate';
import { OnboarderTemplateData } from '../../templates/OnboarderTemplate';
import siteConfig from '../../../site.config.json';

// Map site.config.json to OnboarderTemplateData
// Reusing the same data mapping logic as OnboarderDemo to ensure consistency
const getStartHereData = (): OnboarderTemplateData => {
    return {
        identity: {
            name: siteConfig.identity.name,
            handle: siteConfig.identity.handle,
            avatar: siteConfig.identity.avatar,
            welcome: siteConfig.identity.welcome,
            bio: siteConfig.identity.bio,
        },
        hero: {
            welcome: siteConfig.identity.welcome,
            headline: siteConfig.content.heroHeadline,
            subline: siteConfig.content.heroSubtitle,
            ctaText: siteConfig.hero.ctaText,
            ctaLink: siteConfig.hero.ctaLink,
        },
        learningPath: siteConfig.learningPath.map(step => ({
            id: step.id,
            title: step.title,
            description: step.description,
            status: step.status as 'completed' | 'active' | 'upcoming',
            link: step.link,
            linkText: step.linkText,
        })),
        resources: siteConfig.resources.map(res => ({
            id: res.id,
            title: res.title,
            description: res.description,
            icon: res.icon,
            tag: res.tag,
            link: res.link,
        })),
        faq: siteConfig.faq.map(item => ({
            question: item.question,
            answer: item.answer,
        })),
        newsletter: {
            title: siteConfig.newsletter.title,
            description: siteConfig.newsletter.description,
            buttonText: siteConfig.newsletter.buttonText,
        },
        social: {
            twitter: siteConfig.social.twitter,
            youtube: siteConfig.social.youtube,
            discord: siteConfig.social.discord,
            telegram: siteConfig.social.telegram,
            telegramBusiness: siteConfig.social.telegramBusiness,
            patreon: siteConfig.social.patreon,
        },
    };
};

const StartHereDemo: React.FC = () => {
    const data = getStartHereData();
    return <StartHereTemplate data={data} />;
};

export default StartHereDemo;
